import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import router from './router';
import VueFlashMessage from '@smartweb/vue-flash-message';
import 'admin-lte/dist/css/adminlte.min.css';
import VCalendar from 'v-calendar'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.config.productionTip = false;
Vue.use(VueFlashMessage);
Vue.use(VCalendar, { componentPrefix: 'vc' });
Vue.use(VueSweetalert2)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

